// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__Dzg1n","LogoIcon":"Logo_LogoIcon__nQPA4","LogoSmall":"Logo_LogoSmall__zXWbY","LogoNavbar":"Logo_LogoNavbar__oKPo2"};